<template>
    <kt-panel v-if="findGroupsStatus === 'success'">
        <div class="accordion accordion-toggle-arrow" id="userCatFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#catFilterForm"
                         aria-controls="catFilterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="catFilterForm" class="collapse" aria-labelledby="catFilterForm" data-parent="#userCatFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="full_name">
                                                {{ $t('label.full_name') }}
                                            </kt-form-label>
                                            <kt-form-control ref="full_name"
                                                             dir="ltr"
                                                             name="full_name"
                                                             id="full_name"
                                                             v-model="query.full_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="group">
                                                {{ $t('label.group') }}
                                            </kt-form-label>
                                            <select
                                                id="user_ids"
                                                name="user_ids"
                                                class="form-control kt-selectpicker"
                                                v-model="query.group_id"
                                            >
                                                <option
                                                    v-bind:key="index"
                                                    v-for="(group, index) in groupsData"
                                                    :value="group.id"
                                                >
                                                    {{ group.group_name }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="marketing_level">
                                                {{ $t('label.user_level') }}
                                            </kt-form-label>
                                            <kt-form-select size="3"
                                                            id="marketing_level"
                                                            class="form-control"
                                                            name="marketing_level"
                                                            v-model="query.marketing_level">
                                                <option
                                                    v-for="(marketing_level, index) in marketing_levels"
                                                    v-bind:key="index"
                                                    v-bind:value="marketing_level.value"
                                                    :selected="query.marketing_level === marketing_level.value"
                                                >
                                                    {{ marketing_level.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="birth_date_from_date">
                                                {{ $t('label.birth_date') + ' ('  + $t('label.from_date') + ')' }}
                                            </kt-form-label>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                :clearable="true"
                                                v-model="query.birth_date_from_date" type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.birth_date') + ' ('  + $t('label.to_date') + ')' }}
                                            </kt-form-label>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                :clearable="true"
                                                v-model="query.birth_date_to_date" type="date" />
                                        </kt-form-group>
                                    </kt-col>

                                </kt-form-row>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="register_date_from_date">
                                                {{ $t('label.register_date') + ' ('  + $t('label.from_date') + ')' }}
                                            </kt-form-label>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                :clearable="true"
                                                v-model="query.register_date_from_date" type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="register_date_to_date">
                                                {{ $t('label.register_date') + ' ('  + $t('label.to_date') + ')' }}
                                            </kt-form-label>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                :clearable="true"
                                                v-model="query.register_date_to_date" type="date" />
                                        </kt-form-group>
                                    </kt-col>
<!--                                    <kt-col xs="12" sm="6" md="6">-->
<!--                                        <kt-form-group>-->
<!--                                            <kt-form-label for="minimum_wage">-->
<!--                                                {{ $t('label.minimum_wage') + ' (' + $t('label.rial') + ')' }}-->
<!--                                            </kt-form-label>-->
<!--                                            <kt-form-control-->
<!--                                                ref="minimum_wage"-->
<!--                                                dir="ltr"-->
<!--                                                name="minimum_wage"-->
<!--                                                id="minimum_wage"-->
<!--                                                v-model="query.minimum_wage"-->
<!--                                            />-->
<!--                                        </kt-form-group>-->
<!--                                    </kt-col>-->
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

import {mapGetters} from "vuex";
import {marketingLevel, marketingLevelStr} from "@/constants/marketingLevel";
import $ from "jquery";
import {i18n} from "@/plugins/i18n";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            cat_id: this.$route.params.hashid,
            query: {},
            marketing_levels: [
                {
                    name: null,
                    value: null
                },
                {
                    name: marketingLevelStr.level_1,
                    value: marketingLevel.level_1,
                },
                {
                    name: marketingLevelStr.level_2,
                    value: marketingLevel.level_2,
                },
                {
                    name: marketingLevelStr.level_3,
                    value: marketingLevel.level_3,
                },
            ],
        }
    },
    computed: {
        ...mapGetters('user', [
            'groupsData',
            'findGroupsStatus',
        ])
    },
    methods: {
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
    mounted() {
        this.$store.dispatch('user/fetchCategoryGroups', this.cat_id).finally(() => {
            this.runSelectPicker()
        })
    }
}
</script>